module.exports = __webpack_public_path__ + "img/goodsC4.9e8fbc13.png";